<app-helixbook-search></app-helixbook-search>

<ng-container *ngFor="let item of keyboards$ | async; let first = first">
  <div
    *ngIf="item.keys.length"
    class="grid grid-nowrap align-items-center typography typography-subheadline grey-500 typography-paragraph"
    [ngClass]="{ 'mt-40': !first }"
  >
    {{ item.title }}
    <div class="right-divider full-width"></div>
  </div>

  <app-button-keyboard
    [keyboard]="item.keys"
    [activeKey]="(repository.activeKey$ | async) ?? ''"
    (selectedKey)="selectKey($event)"
  ></app-button-keyboard>
</ng-container>
